<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve"
       version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 25406 25406"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <rect class="fil0" width="25406" height="25406" rx="2478" ry="2478" />
   <g id="_595377768">
   <rect class="fil1 str0" x="3202" y="3203" width="19001" height="19001" rx="1770" ry="1770" />
     <line class="fil1 str0" x1="12703" y1="3203" x2="12703" y2="22204" />
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'SwitchDouble',
};
</script>

<style scoped>
.str0 {
  stroke: #FEFEFE;
  stroke-width: 1156.77
}

.fil1 {
  fill: none
}

.fil0 {
  fill: #CCCCCC
}
</style>
